import { useTimeout } from '@fuse/hooks';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProgressPill } from 'app/components/ProgressPill';

type Props = {
	delay?: number;
	label?: string;
};
const FuseLoading = ({ delay, label = 'Loading' }: Props) => {
	const { t, ready } = useTranslation(undefined, { useSuspense: false });

	const [showLoading, setShowLoading] = useState(!delay);

	useTimeout(() => {
		setShowLoading(true);
	}, delay);

	if (!showLoading) {
		return null;
	}

	return (
		<>
			{/* full page flex div to force footer to bottom */}
			<div className="flex flex-1 flex-col items-center justify-center" />
			<ProgressPill
				messageTitle={ready ? t(label) : '\u00A0'}
				messageText={ready ? t('Please wait...') : '\u00A0'}
				size="medium"
			/>
		</>
	);
};

export default FuseLoading;
